import { useQuery } from "@tanstack/react-query";
import { configuration } from "../../../../configuration";
import { FetchError } from "../../../types";
import { GetMeetingNotesDto } from "../../../types/meetings/notes";
import { useAccessToken } from "../../../use-access-token";
import { queryKeys } from "../../queryKeys";

const useGetPrivateMeetingNotesRequest = (meetingGuid: string) => {
  const { getAccessToken } = useAccessToken();

  async function getPrivateMeetingNotesRequest(): Promise<GetMeetingNotesDto> {
    const accessToken = await getAccessToken();

    const response = await fetch(`${configuration.apiRootUrl}/meetings/${meetingGuid}/private-notes`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getPrivateMeetingNotesRequest };
};

const useGetPrivateMeetingNotes = (meetingGuid: string) => {
  const { getPrivateMeetingNotesRequest } = useGetPrivateMeetingNotesRequest(meetingGuid);

  return useQuery({
    queryKey: queryKeys.meetings.getPrivateMeetingNotes(meetingGuid),
    queryFn: getPrivateMeetingNotesRequest,
  });
};

export { useGetPrivateMeetingNotes };
